import type { ReactElement } from 'react';
import React, { useRef } from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';

import styles from './IDScan.scss';
import useIDScan from './hooks/useIDScan';
import type { InputProvider } from './sdk/idscan-jcs';

interface Props {
  showError: (translationErrorMessage?: ReactElement) => void;
  defaultInputProvider?: InputProvider;
  onJourneyStart?: () => void;
  onJourneyComplete?: () => void;
  onJourneyInitialized?: () => void;
  onJourneyRefId?: (jid: string | undefined) => void;
}

const IDScan: React.FC<Props> = ({
  showError,
  defaultInputProvider,
  onJourneyStart,
  onJourneyComplete,
  onJourneyInitialized,
  onJourneyRefId
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useIDScan(
    containerRef,
    showError,
    defaultInputProvider,
    onJourneyStart,
    onJourneyComplete,
    onJourneyInitialized,
    onJourneyRefId
  );

  return (
    // eslint-disable-next-line react/no-unknown-property
    <div wsdk-container="true" ref={containerRef}>
      <LoadingIndicator className={styles.loading} loading />
    </div>
  );
};

export default IDScan;
